import React, { useState, useEffect } from "react";
import { CampaignViewDetailsViewAttachmentInfoProps } from "./campaign-view-details-view-attachment-info.props";
import UploadDropDown from "./upload-dropdown";
import "./campaign-view-details-view-attachment-info.scss";
import UploadFileAttachment from "./upload-file-attachment";
import UploadLinkUrlAttachment from "./upload-link-url-attachment";
import ListAttachMents from "./list-attachments";
import { getAttachments } from "../../../../../../api/campaign";
import { AlertComponent } from "../../../../../../common/components";

const CampaignViewDetailsViewAttachmentInfo: React.FC<
  CampaignViewDetailsViewAttachmentInfoProps
> = ({ setLoading, campaignId, permissions }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
  };

  const fetchAttachments = async () => {
    setLoading(true);
    try {
      const response = await getAttachments(campaignId);
      setAttachmentsList(response?.data?.data);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message || "Failed to get lead attachments."
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [campaignId]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  return (
    <div className="campaign-list-view-details-view-box-attachment-info">
      <div className="campaign-list-view-details-view-box-attachment-info-header">
        <div className="campaign-list-view-details-view-box-attachment-info-header-text">
          Attachments
        </div>
        <div>
          <UploadDropDown
            selectedOption={selectedOption}
            handleChange={handleOptionChange}
            disabled={!permissions?.canWrite}
          />
          <UploadFileAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            campaignId={campaignId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
          <UploadLinkUrlAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            campaignId={campaignId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
        </div>
      </div>
      {attachmentsList?.length > 0 ? (
        <div className="campaign-list-view-details-view-box-attachment-info-list">
          <ListAttachMents
            campaignId={campaignId}
            attachmentsList={attachmentsList}
            fetchAttachments={fetchAttachments}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            permissions={permissions}
          />
        </div>
      ) : (
        <div className="campaign-list-view-details-view-box-attachment-info-no-data">
          No Attachments
        </div>
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default CampaignViewDetailsViewAttachmentInfo;
